import EventEmitter from 'events';

export interface ITsResponsiveUtilsService {
    getOrientation(): string;
    isPortrait(): boolean;
    isLandscape(): boolean;
    width(): number;
    height(): number;
}

export class TsResponsiveUtilsService extends EventEmitter implements ITsResponsiveUtilsService {
    private window?: Window;

    constructor(window: Window) {
        super();
        this.window = window;
        this._initListeners();
    }

    _initListeners() {
        this.window?.addEventListener('orientationchange', () => {
            this.emit('orientationchange', this.getOrientation());
        });
    }

    getOrientation() {
        return this.width() > this.height() ? 'landscape' : 'portrait';
    }

    isPortrait() {
        return this.height() > this.width();
    }

    isLandscape() {
        return this.height() < this.width();
    }

    width() {
        return this.window?.document.body.clientWidth as number;
    }

    height() {
        return this.window?.document.body.clientHeight as number;
    }
}
